/* eslint-disable react/prop-types */
import React from 'react';
import { createPortal } from 'react-dom';
import { KatLink, KatModal } from '@amzn/katal-react';
import { Trans } from 'react-i18next';
import { useRouter } from 'next/router';
import { GUIDELINES } from 'src/constants/pages';

interface CommunityGuidelinesModalProps {
  visible: boolean;
  title: string;
  onClose: () => void;
}

const CommunityGuidelinesModal: React.FC<CommunityGuidelinesModalProps> = ({
  visible, onClose, title,
}) => {
  const { basePath } = useRouter();
  return createPortal(
    <KatModal
      data-testid="guidelines-modal"
      title={title}
      visible={visible}
      onClose={onClose}
    >
      <Trans
        i18nKey="guidelines_tooltip_modal_content"
        components={{
          katlink: <KatLink
            data-testid="guidelines-page-link"
            href={`${basePath}${GUIDELINES}`}
            className="cursor-pointer"
            target="_blank"
          />,
          ul: <ul />,
          li: <li />,
        }}
      />
    </KatModal>,
    document.querySelector('#seller-forums') as Element,
  );
};
export default CommunityGuidelinesModal;
